import React from "react";
import { Box } from "@mui/material";
function JobDetailWrapper({ children }) {
  return (
    <Box display={"flex"} alignItems={"start"} gap={1}>
      {children}
    </Box>
  );
}

export default JobDetailWrapper;
